module.exports = __webpack_public_path__ + "img/credit-card-apple.b0aad045.png";